export default "__VITE_ASSET__DI0Vqq5$__"